module.exports = __webpack_public_path__ + "static/media/leaf.5d4653f9.svg";